import React, { useEffect, useState, useCallback, useRef } from 'react';
import useApp from 'hooks/useApp'
import { Layer, LayerBottom, Button, NoData } from 'components'
import styles from '../index.module.css'
import { useRecoilState, useRecoilValue, useSetRecoilState, atom } from 'recoil'
import Lib from 'library';
import { benefitCardLayerShowState } from './states'
import { financeCardDetailLayerController } from '../home/states'
import CardDetailLayer from '../home/FinanceCardDetailLayer'
import CompanySearchNone from 'views/life/CompanySearchNone';
import { confirmLayerShowState } from 'views/mydata/manage/states';

const benefitDataState = atom({
	key: "benefitDataState",
	default: undefined
})

const cardCorpDataState = atom({
	key: "cardCorpData",
	default: undefined
})

export const keyBnftsState = atom({
	key: "keyBnftsState",
	default: []
})

export const keyCorpsState = atom({
	key: "keyCorpsState",
	default: []
})

export const keyBnftGrpState = atom({
	key: "keyBnftGrpState",
	default: ""
})

const benefitCountState = atom({
	key: "benefitCountState",
	default: 0
})

const cardCorpCountState = atom({
	key: "cardCorpCountState",
	default: 0
})


const BenefitCardDetailLayer = () => {

	const [show, setShow] = useRecoilState(benefitCardLayerShowState)
	const win = useRef()

	return (
		<Layer show={show} closeLayer={() => setShow(false)} left={<i className="icon_arrow_back" onClick={() => setShow(false)} />} right={<></>} ref={win}>
			<LayerContent win={win} />
		</Layer>
	)
}

const LayerContent = ({ win }) => {

	const [cardbnftLst, setCardbnftLst] = useState()
	const [target, setTarget] = useState(""); // target
	const [page, setPage] = useState(1); // 무한 스크롤 숫자
	const mounted = useRef(false);
	const searchBar = useRef()
	const [showLayer, setShowLayer] = useState(false);

	const setShowDetailLayer = useSetRecoilState(financeCardDetailLayerController)

	const keyBnftGrp = useRecoilValue(keyBnftGrpState)
	const keyBnfts = useRecoilValue(keyBnftsState)
	const keyCorps = useRecoilValue(keyCorpsState)

	const [benefitCount, setBenefitCount] = useRecoilState(benefitCountState)

	const [benefitData, setBenefitData] = useRecoilState(benefitDataState)
	const setCardCorpData = useSetRecoilState(cardCorpDataState)
	const [cardCorpCount, setCardCorpCount] = useRecoilState(cardCorpCountState)
	const [commonCode, setCommonCode] = useState([])

	const getCardBnft = async () => {
		// 혜택 공통코드 조회
		Lib.myGet('/api/auth/sncnApis/v1', data => {
			const dataList = data.filter((item) => item.api_nm == '금융상품추천')[0].api_codes
			const commonCodeList = dataList
			setCommonCode(dataList)
			
			let newList = []
			for(var i=0; i < commonCodeList.length; i++) {
				const { cd_nm, cd_id} = commonCodeList[i];
				const group = cd_id.substr(6, 8)
				// 그룹코드 확인
				if(group === '00'){
					newList[i] = {
						commGrpCd : cd_id,
						commGrpNm : cd_nm,
						// commCd: cd_id,
						checked: false,
						list: [] 
					}
				}else{
					for(var k=0; k < newList.length; k++) {
						const gruopId = newList[k].commGrpCd.substr(0, 6)
						const bnfList = cd_id.substr(0, 6)
						if(gruopId == bnfList){
							newList[k].list.push({
								commCd: cd_id,
								commNm: cd_nm,
								// commDesc: 혜택설명,
								// commDesc2: 혜택설명,
								checked: false
							})
						}
					}
				}
			}
			setBenefitCount(0)
			setBenefitData(newList)
		})

		// 조회가능한 카드사 목록
		const cardCorp = [
				{
					"commGrpCd": "CARD_CORP",
					"commGrpNm": "카드사",
					"commCd": "CRD001",
					"commNm": "현대백화점카드",
					"commDesc": "현대백화점카드",
					"commDesc2": "",
					"useYn": "Y",
					"sortNo": 1,
					"checked": true
				},
				{
					"commGrpCd": "CARD_CORP",
					"commGrpNm": "카드사",
					"commCd": "CRD001",
					"commNm": "BC카드",
					"commDesc": "BC카드",
					"commDesc2": "",
					"useYn": "Y",
					"sortNo": 1,
					"checked": true
				},
				{
					"commGrpCd": "CARD_CORP",
					"commGrpNm": "카드사",
					"commCd": "CRD001",
					"commNm": "KB국민카드",
					"commDesc": "KB국민카드",
					"commDesc2": "",
					"useYn": "Y",
					"sortNo": 1,
					"checked": true
				},
				{
					"commGrpCd": "CARD_CORP",
					"commGrpNm": "카드사",
					"commCd": "CRD002",
					"commNm": "NH농협카드",
					"commDesc": "NH농협카드",
					"commDesc2": "",
					"useYn": "Y",
					"sortNo": 2,
					"checked": true
				},
				{
					"commGrpCd": "CARD_CORP",
					"commGrpNm": "카드사",
					"commCd": "CRD003",
					"commNm": "IBK기업은행",
					"commDesc": "IBK기업은행",
					"commDesc2": "",
					"useYn": "Y",
					"sortNo": 3,
					"checked": true
				},
				{
					"commGrpCd": "CARD_CORP",
					"commGrpNm": "카드사",
					"commCd": "CRD004",
					"commNm": "롯데카드",
					"commDesc": "롯데카드",
					"commDesc2": "",
					"useYn": "Y",
					"sortNo": 4,
					"checked": true
				},
				{
					"commGrpCd": "CARD_CORP",
					"commGrpNm": "카드사",
					"commCd": "CRD005",
					"commNm": "삼성카드",
					"commDesc": "삼성카드",
					"commDesc2": "",
					"useYn": "Y",
					"sortNo": 5,
					"checked": true
				},
				{
					"commGrpCd": "CARD_CORP",
					"commGrpNm": "카드사",
					"commCd": "CRD006",
					"commNm": "신한카드",
					"commDesc": "신한카드",
					"commDesc2": "",
					"useYn": "Y",
					"sortNo": 6,
					"checked": true
				},
				{
					"commGrpCd": "CARD_CORP",
					"commGrpNm": "카드사",
					"commCd": "CRD007",
					"commNm": "우리카드",
					"commDesc": "우리카드",
					"commDesc2": "",
					"useYn": "Y",
					"sortNo": 7,
					"checked": true
				},
				{
					"commGrpCd": "CARD_CORP",
					"commGrpNm": "카드사",
					"commCd": "CRD008",
					"commNm": "하나카드",
					"commDesc": "하나카드",
					"commDesc2": "",
					"useYn": "Y",
					"sortNo": 8,
					"checked": true
				},
				{
					"commGrpCd": "CARD_CORP",
					"commGrpNm": "카드사",
					"commCd": "CRD009",
					"commNm": "현대카드",
					"commDesc": "현대카드",
					"commDesc2": "",
					"useYn": "Y",
					"sortNo": 9,
					"checked": true
				}
			]
		setCardCorpData(cardCorp)
		setCardCorpCount(cardCorp.length)



		// 원본
		// const array = []
		// // 전체 혜택 그룹 조회 -> 6개나옴
		// const list = await Lib.get(`/api/comm/cd/CARD_BNFT`)
		// console.log({ list })
		// // 각 그룹에 혜택ID 조회 -> 그룹에 혜당되는 하위 혜택 조회됨
		// list.forEach(item => {
		// 	array.push(Lib.get(`/api/comm/cd/${item.commCd}`))
		// })
		// 조회가능한 카드사 목록
		// Lib.get(`/api/comm/cd/CARD_CORP`, data => {
		// 	console.log('/api/comm/cd/CARD_CORP',data)
		// 	setCardCorpData(data.map(item => {
		// 		item.checked = true
		// 		return item
		// 	}))
		// 	setCardCorpCount(data.length)
		// })
		// 혜택 구분하여 원하는 데이터 형태로 가공
		// Promise.allSettled(array).then(results => {
		// 	const newList = results.map(item => {
		// 		if (item.status === "fulfilled") {
		// 			return {
		// 				...item.value[0],
		// 				checked: false,
		// 				list: item.value.map(item => {
		// 					return {
		// 						...item,
		// 						checked: false
		// 					}
		// 				})
		// 			}
		// 		} else {
		// 			return undefined
		// 		}
		// 	})
		// 	console.log('원본 results',results)
		// 	setBenefitData(newList)
		// 	console.log('원본 newList',newList)
		// })
	}
	
	// 카드리스트 조회
	const getCardbnftPage = (n, benefitGroup, corps, benefits) => {
		if (!n) n = 1
		if (n === 1) setPage(1)
		if (!benefitGroup) benefitGroup = keyBnftGrp
		if (!benefits) benefits = keyBnfts
		if (!corps) corps = keyCorps

		const allBenefitGroup = benefitGroup ? `&cate_grp=${benefitGroup}`: ''
		const allBenefits = benefits !== undefined ?  benefits.join('&cate=') : ''
		const allCorps = corps.length < 11 ? `${corps.join('&card_co=')}` : ''
		// 전체일 경우 생략처리
		// Lib.myGet(`/api/recomm/card/v1?page=1&limit=10`, data => {
		Lib.myGet(`/api/recomm/card/v1?page=${n}&limit=10${allBenefitGroup}${allBenefits ? '&cate=' + allBenefits : ''}${allCorps ? '&card_co=' + allCorps : ''}`, data => {
			console.log('재판매모델 api 결과값 >>', data.data)
			
			setCardbnftLst(prevState => {
				if (prevState && n > 1) {
					return [...prevState, ...data.data]
				} else {
					return data.data
				}
			})
		});
		// 원본
		// Lib.post(`/api/finance/cardbnftPage?pageNo=${n}&rowsPerPage=10&searchVo.keyBnftGrp=${benefitGroup || ""}&searchVo.keyBnfts=${benefits || []}&searchVo.keyCorps=${corps || []}`, data => {
		// 	setCardbnftLst(prevState => {
		// 		if (prevState && n > 1) {
		// 			return [...prevState, ...data]
		// 		} else {
		// 			return data
		// 		}
		// 	})
		// });
	}

	/* const getCardbnftLst = () => {
		Lib.post(`/api/finance/cardbnftLst?searchVo.keyBnftGrp=${keyBnftGrp || ""}&searchVo.keyBnfts=${keyBnfts || []}&searchVo.keyCorps=${keyCorps || []}`, data => setCardbnftLst(data));
	} */

	// 두 번이상 전체 목록 레이어 오픈 시 공통코드 오류로 useEffect로 확인
	useEffect(() => {
		if(commonCode.length == undefined ||  commonCode.length == 0){
			getCardBnft()
		}
		console.log('commonCode >> ', commonCode)
	}, [commonCode]);
	// 혜택 코드 -> 네임으로
	const bnftNameReturn = (code) =>{
		if(commonCode !== undefined ||  commonCode.length !== 0){
			return `#${commonCode.filter((item) => item.cd_id == code)[0].cd_nm} `
		}else{
			Lib.myGet('/api/auth/sncnApis/v1', data => {
				// 혜택 공통코드
				const codeList = data.filter((item) => item.api_nm == '금융상품추천')[0].api_codes
				return `#${codeList.filter((item) => item.cd_id == code[0].category)[0].cd_nm} `
			})
		}
	};
	// 카드상세 열기
	const financeDetailRouter = (cardId) => {
		// navigate('/recommend/financeCardDetail', { state: { cardId: cardId } });
		setShowDetailLayer({
			show: true,
			cardId: cardId
		})
	};

	// 인피니티스크롤처리
	const onIntersect = ([entry]) => {
		if (entry.isIntersecting) {
			setPage(prev => prev + 1)
		}
	};

	// 스크롤 조정
	const scrollBinding = e => {
		const wrap = win.current.firstElementChild
		if (wrap.scrollTop >= 100) {
			searchBar.current.style.paddingTop = 0
			searchBar.current.children[1].classList.remove("mt_10")
		} else {
			searchBar.current.style.paddingTop = "20px"
			searchBar.current.children[1].classList.add("mt_10")
		}
	}

	useEffect(() => {
		if (page > 1) getCardbnftPage(page)
	}, [page])

	useEffect(() => {
		if (win.current) {
			const wrap = win.current.firstElementChild
			if (!wrap.getAttribute("binded")) {
				wrap.setAttribute("binded", true)
				wrap.addEventListener("scroll", scrollBinding)
			}
		}
	}, [win.current])

	useEffect(() => {
		mounted.current = true;
		if (!benefitData) getCardBnft()
		getCardbnftPage(1);

		return () => {
			mounted.current = false
			win.current?.firstElementChild && win.current.firstElementChild.removeEventListener("scroll", scrollBinding)
			// setBenefitCount(0)
		}
	}, [])

	useEffect(() => {
		let observer;
		if (target) {
			// callback 함수, option
			observer = new IntersectionObserver(onIntersect, {
				threshold: 0.4,
			});
			observer.observe(target); // 타겟 엘리먼트 지정
		}
		return () => observer && observer.disconnect();
	}, [target]);

	/* useEffect(() => {
		if (infiniteN === 0) { return false }
		getCardbnftPage(infiniteN);
	}, [infiniteN]) */

	//if (!cardbnftLst) return null;

	return (
		<div className="page">
			<div ref={searchBar} className="padding mutableBar translucent">
				<h3>혜택별 카드</h3>
				<div className="filter-group mt_10" style={{ transitoin: "margin 0.3s" }}>
					<div onClick={() => setShowLayer(true)} style={{ width: "100%" }}>
						<span className="ellipsis flex-align_center" style={{ width: "100%", justifyContent: "flex-end" }}>
							{
								benefitCount > 0 &&
								<span>혜택({benefitCount})∙</span>
							}
							{(() => {
								if (keyCorps.length === 0 || keyCorps.length === cardCorpCount) return <span>카드사 전체</span>
								return <span className="ellipsis" style={{ maxWidth: "70%", flexGrow: 0 }}>{keyCorps.join(", ")}</span>
							})()
							}
							<i className="icon icon_filter ml_5" />
						</span>
					</div>
				</div>
			</div>
			<ul className={`${styles["benefit-list"]} list-bg mt_100 cmm-list`}>
				{!cardbnftLst ? (
					Array.apply(null, Array(10)).fill(undefined).map((emt, index) =>
						<li key={index}>
							<div className="img-box skeleton" style={{ width: "3.8rem", height: "6rem" }}></div>
							<div className={`${styles.content} ml_20`}>
								<p className="skeleton" style={{ width: "6rem", height: "1rem" }}></p>
								<strong className="skeleton mt_5" style={{ width: "14rem", height: "1rem" }}></strong>
								<div className={`${styles["benefit-info"]} mt_10`}>
									<span className="skeleton" style={{ width: "3rem", height: "1rem" }}></span>
									<span className="skeleton" style={{ width: "3rem", height: "1rem" }}></span>
									<span className="skeleton" style={{ width: "3rem", height: "1rem" }}></span>
								</div>
							</div>
						</li>
					)
				) : (
					cardbnftLst.length > 0 && commonCode.length > 0 ?
						cardbnftLst.map((card, index) =>
							<li key={index} onClick={() => financeDetailRouter(card.cardId)}>
								<div className="img-box" style={{ width: "6rem", height: "6rem" }}>
									<img src={card.cardImgUrl} alt="" />
								</div>
								<div className={`${styles.content} ml_20`}>
									<p>{card.cardCoNm}</p>
									<strong className="mt_5">{card.cardNm}</strong>
									<div className={`${styles["benefit-info"]} mt_10`}>
										{card.cardBenefits.filter((item) => item.priority < 5).map((category, index) =>  
											<em key={index}>{bnftNameReturn(category.category)}</em>
										)}
											{/* {card.cardBenefits.map((category, index) => 
											index < 4 && <span key={index}>{bnftNameReturn(category.category)}</span>
											)} */}
									</div>
								</div>
							</li>
						)
						:
						<NoData text="검색된 카드가 없습니다." />
				)}
				{/* 무한 스크롤 타켓 위치 */}
				<li ref={setTarget}></li>
			</ul>
			<SelectLayer
				show={showLayer}
				closeLayer={() => setShowLayer(false)}
				getCardbnftPage={getCardbnftPage}
			/>

			<CardDetailLayer />
		</div>
	)
}

// 옵션레이어 처리
const SelectLayer = ({ show, closeLayer, getCardbnftPage }) => {

	const [keyBnftGrp, setKeyBnftGrp] = useRecoilState(keyBnftGrpState)
	const setKeyBnfts = useSetRecoilState(keyBnftsState)
	const setKeyCorps = useSetRecoilState(keyCorpsState)
	const setBenefitCount = useSetRecoilState(benefitCountState)

	const [benefitData, setBenefitData] = useRecoilState(benefitDataState)
	const [cardCorpData, setCardCorpData] = useRecoilState(cardCorpDataState);
	const [localBenefitData, setLocalBenefitData] = useState()
	const [localCardList, setLocalCardList] = useState()
	
	const [disabled, setDisabled] = useState(true)

	// 카테고리 그룹 클릭 처리
	const categoryClick = cd => {
		// 클릭한 카테고리 그룹 하위 리스트 재조회 해서 뿌려줌
		// cd = 선택한 카테고리 코드 받아옴
		setLocalBenefitData(prev => {
			// 전체 카테고리 데이터중에서 맵핑함!
			const newData = prev.map(item => {
				// 일단 복사(두 벌로 이루어지게)
				const clone = Lib.deepCopy(item)
				// 각각의 데이터에서 그룹코드가 commGrpCd 사용자가 클릭한 코드랑 같은거 찾음 cd
				if (clone.commGrpCd === cd) {
					// 그룹코드 체크 처리 하고
					clone.checked = !clone.checked
					// 그룹이 체크 안 된 거는
					if (!clone.checked) {
						// 그룹 하위 list 모두 체크 비활성 처리
						clone.list.map(item => {
							item.checked = false
						})
					}
				} else {
					// 사용자가 클릭하지 않은 그룹코드는 체크 비활성 처리 
					clone.checked = false
					clone.list.map(item => {
						item.checked = false
					})
				}
				// 처리 후 데이터 리턴
				return clone
			})
			// 맵핑 데이터 리턴
			return newData
		})
	}

	const onClickBntList = (commCd) => {
		// 사용자가 클릭한 혜택 코드 commCd
		setLocalBenefitData(prev => prev.map(item => {
			// 혜택코드 리스트(그룹아님) 복사
			const clone = Lib.deepCopy(item)
			// 사용자가 클릭한 코드가 리스트 내에서 동일한 코드 있으면 체크처리/비활성처리 함
			const newList = clone.list.map(item => {
				if (item.commCd === commCd) item.checked = !item.checked
				return item
			})
			clone.list = newList
			return clone
		}))
	}

	const onCardList = useCallback((commNm, index) => {
		setLocalCardList(prevState => {
			const _newState = prevState.map((item, idx) => {
				return index === idx ? { ...item, checked: !item.checked } : item
			});
			return _newState;
		});
	}, [])

	const onSetCardList = () => {
		let benefitList = [], keyBnftGrp
		localBenefitData.forEach(item => {
			if (item.checked) {
				keyBnftGrp = item.commGrpCd
				item.list.forEach(item => {
					if (item.checked) {
						benefitList.push(item.commNm)
					}
				})
			}
		})

		// 카드사
		const keyCorps = localCardList.filter(item => {
			return item.checked
		}).map(item => item.commNm)
		// 혜택리스트
		const keyBenefits = localBenefitData.filter((item) => item.commGrpCd == keyBnftGrp)[0]
		const keyBenefitList = keyBenefits.list.filter(item => {
			return item.checked
		}).map(item => item.commCd)

		setKeyCorps(keyCorps)
		setKeyBnfts(keyBenefitList)
		setBenefitCount(keyBenefitList.length)
		setBenefitData(localBenefitData)
		setCardCorpData(localCardList)
		setKeyBnftGrp(keyBnftGrp)

		getCardbnftPage(1, keyBnftGrp, keyCorps, keyBenefitList)
		// getCardbnftPage(1, keyBnftGrp, keyCorps, benefitList)
		closeLayer()
	}

	useEffect(() => {
		if (localBenefitData && cardCorpData) {
			// 기존에 Grp 혜택내의 하나 이상 선택이 필수 일 때, 코드
			// 혜택하위카테고리
			const cond1 = localBenefitData.some(item => {
				return item.list.some(item => {
					return item.checked
				})
			})

			// 카드사
			const cond2 = localCardList.some(item => {
				return item.checked
			})

			// 혜택그룹카테고리
			const grpSelect = document.querySelectorAll(".checkMark.on").length > 0;
			setDisabled(!(cond2 && (cond1 || grpSelect)));
		}
	}, [localBenefitData, localCardList])

	useEffect(() => {
		if (show) {
			if (keyBnftGrp) {
				setLocalBenefitData(benefitData.map((item, index) => {
					if (item.commGrpCd === keyBnftGrp) {
						return {
							... item,
							checked: true
						}
					} else {
						return item;
					}
				}));
			} else {
				setLocalBenefitData(Lib.deepCopy(benefitData))
			}
			setLocalCardList(Lib.deepCopy(cardCorpData))
		}
	}, [show])

	if (!benefitData) return null;

	return (
		<LayerBottom title="혜택" show={show} closeLayer={closeLayer} outside={
			<div className="button-group">
				<Button className="btn btn--big btn-layer" disabled={disabled} onClick={onSetCardList}>확인</Button>
			</div>
		}>
			<ul className="terms-list accordion-list">
				{
					localBenefitData &&
					localBenefitData.map((item, parentIndex) => {
						const { commGrpCd, commGrpNm, commNm, checked, list } = item
						return (
							<li key={parentIndex} className={checked ? 'active' : ''}>
								<div className="flex-justify_between align_center" onClick={e => categoryClick(commGrpCd)}>
									<div className="chk noChk">
										<i className={`checkMark${checked ? " on" : ""}`} />
										{/* <input
											type="checkbox"
											id={`check${parentIndex}`}
											checked={checked}
											name="state"
											onChange={(e) => onCheckBoxHanlder(e, commCd, parentIndex)}
										/> */}
										<label htmlFor={`check${parentIndex}`}>
											<span>{commGrpNm.replace("카드혜택 ", "")}</span>
										</label>
									</div>
									<i className="icon icon_arrow_sm bottom" />
								</div>
								<div className="menu-open mt_10">
									<ul className="menu-select">
										{list && list.map(({ commCd, checked, commNm }, index) => <li key={index} onClick={e => onClickBntList(commCd)} className={checked ? 'on' : ''}>+ {commNm}</li>)}
									</ul>
								</div>
							</li>
						)
					})
				}
			</ul>
			<h3 className="mt_40" style={{ fontWeight: 300, marginBottom: "0.8rem" }}>카드사</h3>
			<hr className="my_20" />
			<ul className="menu-select" style={{ padding: 0, background: "#fff" }}>
				{localCardList && localCardList.map((card, index) => {
					return <li key={index} className={card.checked ? "on" : ""} onClick={() => onCardList(card.commNm, index)}>+ {card.commNm}</li>
				})}
			</ul>
		</LayerBottom>
	)
}

export default BenefitCardDetailLayer